import React, { ChangeEvent, useMemo } from 'react'
import InputFieldWithManagedState from './input-field/with-managed-state'
import { colors } from '@lib/theme'

interface RangeSliderProps {
  value: number
  setValue: (newValue: number) => void
  min: number
  max: number
  step?: number
  label?: string
  onMouseUp?: () => void
  onTouchEnd?: () => void
  onBlur?: () => void
}

const RangeSlider = ({
  value,
  setValue,
  min,
  max,
  step = 0.1,
  label,
  onMouseUp,
  onTouchEnd,
  onBlur,
}: RangeSliderProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(Number(event.target.value))
  }

  const progress = useMemo(() => {
    const range = max - min
    return ((value - min) / range) * 100
  }, [value, min, max])

  return (
    <div className="flex items-center gap-4">
      {label && <label className="shrink-0 text-sm">{label}</label>}

      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
        style={{
          background: `linear-gradient(to right, ${colors.green} 0%, ${colors.green} ${progress}%, rgba(12,12,12,0.15) ${progress}%, rgba(12,12,12,0.15) 100%)`,
        }}
      />

      <InputFieldWithManagedState
        type="number"
        min={min}
        max={max}
        value={value.toString()}
        setValue={(value) => setValue(Number(value))}
        onBlur={onBlur}
        inputClassName="text-center min-w-[95px]"
      />
    </div>
  )
}

export default RangeSlider
